function parse(address) {
  try {
    return new URL(address);
  } catch (err) {
    return null;
  }
}

function currentOrigin() {
  return typeof window === 'undefined' ? undefined : window.location.origin;
}

// The PWA answers on `pwa.` and on `m.`; the env names one of the two.
function pwaOrigins(environment) {
  const host = environment.VITE_CREDERE_PWA_HOST;

  if (!host) {
    return [];
  }

  return [
    host.replace(/^https:\/\/m\./, 'https://pwa.'),
    host.replace(/^https:\/\/pwa\./, 'https://m.'),
  ];
}

function isWebSubdomain(candidate, web, environment) {
  const domain = environment.VITE_CREDERE_WEB_DOMAIN;

  if (!domain || candidate.protocol !== web.protocol || candidate.port !== web.port) {
    return false;
  }

  const [label, ...rest] = candidate.hostname.split('.');

  return rest.join('.') === domain && /^[a-z0-9-]+$/.test(label);
}

// The web answers on its own host and, when VITE_CREDERE_WEB_DOMAIN is set, on any single-label
// subdomain of it; the embed's own host and the PWA's `pwa.` are subdomains that are not the web.
export function isWebOrigin(origin, environment = import.meta.env) {
  const web = parse(environment.VITE_CREDERE_WEB_HOST);
  const candidate = parse(origin);

  if (!web || !candidate) {
    return false;
  }

  if (candidate.origin === web.origin) {
    return true;
  }

  const notWeb = [environment.VITE_CREDERE_EMBED_HOST, pwaOrigins(environment)[0]];

  if (notWeb.includes(candidate.origin)) {
    return false;
  }

  return isWebSubdomain(candidate, web, environment);
}

// Where this app may run inline trusting the page's `window.CREDERE`.
export function isInternalOrigin(origin, environment = import.meta.env) {
  return isWebOrigin(origin, environment)
    || [environment.VITE_CREDERE_TUNNEL_HOST, ...pwaOrigins(environment)]
      .filter(Boolean)
      .includes(origin);
}

// The address of the web for links the user takes away: the one they are on, when it is the web.
export function webHost(origin = currentOrigin(), environment = import.meta.env) {
  return isWebOrigin(origin, environment) ? origin : environment.VITE_CREDERE_WEB_HOST;
}
